
import Vue from "vue";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";
import Active from "./partnership/Active.vue";
import Pending from "./partnership/Pending.vue";
import axios, { AxiosResponse } from "axios";
import { SchoolModel } from "@/models/academy.model";
import toast from "@/functions/toast.function";
import { saveAs } from "file-saver";

@Component({
  components: {
    Active,
    Pending
  }
})
export default class Partnership extends Vue {
  @Action("actionGetIndustry", {namespace: "misc"})
  private actionGetIndustry: any;
  @Action("actionGetAgreement", { namespace: "partnership" })
  private actionGetAgreement: any;
  @Action("actionUploadAgreement", { namespace: "partnership" })
  private actionUploadAgreement: any;

  @State("industries", {namespace: "misc"})
  private industries: any;
  @State("locale")
  private locale: any;
  @State("school", { namespace: "academy" })
  private school: SchoolModel;

  private industry: any = null;
  private name: string = "";
  private filter: boolean = false;
  private tabs: any = null;
  private isShowDocumentModal: boolean = false;

  private created() {
    this.getTab();
    this.actionGetIndustry()
  }

  private reset() {
    this.industry = null;
    this.name = "";
    this.search();
  }
  private search() {
    this.filter = !this.filter;
  }

  private getTab() {
    const tabPartnership = localStorage.getItem("tab-partnership");
    if (tabPartnership) this.tabs = parseInt(tabPartnership);
    else this.tabs = 0;
  }
  private setTab() {
    if (this.tabs === 0) localStorage.setItem("tab-partnership", "1");
    else localStorage.setItem("tab-partnership", "0");
  }

  private getLabelTranslation() {
    if (this.locale === "id") return "translation";
    return "name";
  }

  private openFile () {
    document.getElementById("partnership-agreement").click();
  }
  private onAgreementChange (event: any) {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("agreement_doc", file);
    this.actionUploadAgreement({
      params: formData,
      success: (response: AxiosResponse) => {
        if (response) toast.success("File uploaded.");
      },
    });
    const ref = this.$refs.agreementRef as any;
    ref.value = "";
  }
  private getAgreement () {
    this.actionGetAgreement({
      params: {
        path: this.school.subpath
      },
      success: (response: AxiosResponse) => {
        this.download(response.data.agreement_doc);
      },
    });
  }

  private download (url: string) {
    const filename = `Agreement Document.${url.split(".").pop()}`;
    axios.get(url, {responseType: "blob"})
      .then((res) => {
        saveAs(res.data, filename);
      })
      .catch((e) => console.warn("Unable to download file!", e));
  }
}
